// Pop-up artwork exported from Figma (HT-Modal-Black Friday, 69:2781). The wave
// is the design's photo with its fade mask baked in, cropped to what shows; it is
// wrapped in an SVG because the Amplify rewrite serves index.html for .webp.
import WaveImage from "../../assets/img/black-friday/bf-modal-wave.svg";
import LetteringTop from "../../assets/img/black-friday/bf-modal-lettering-top.svg";
import LetteringBottom from "../../assets/img/black-friday/bf-modal-lettering-bottom.svg";
// Shared Action Center icons; the close glyph is recoloured in the modal SCSS.
import CloseIcon from "../../assets/img/action-center/close-sm.svg?react";
import ChevronRightIcon from "../../assets/img/action-center/chevron-right-white.svg";

export {
  WaveImage,
  LetteringTop,
  LetteringBottom,
  CloseIcon,
  ChevronRightIcon,
};

// Everything the pop-up paints. Loaded before it opens so the artwork does not
// pop in after the panel.
export const BLACK_FRIDAY_MODAL_IMAGES = [
  WaveImage,
  LetteringTop,
  LetteringBottom,
  ChevronRightIcon,
];
